import {reactive, ref} from 'vue';
import useVuelidate from '@vuelidate/core';
import {helpers, required, maxLength} from '@vuelidate/validators';
import pickBy from 'lodash/pickBy';
import {useCurrentPage} from './useCurrentPage';

export interface HiddenInputs {
    administrativeAreaLevel1?: string;
    administrativeAreaLevel1Code?: string;
    administrativeAreaLevel2?: string;
    administrativeAreaLevel2Code?: string;
    administrativeAreaLevel3?: string;
    administrativeAreaLevel3Code?: string;
    administrativeAreaLevel4?: string;
    administrativeAreaLevel4Code?: string;
    city?: string;
    country?: string;
    countryCode?: string;
    lat?: number;
    lon?: number;
    region?: string;
    remoteAllowed?: boolean;
    remoteEuropa?: boolean;
}

export function useSearchForm(searchParams: Record<string, string>) {
    const {currentPage} = useCurrentPage();

    const hiddenInputs = ref<HiddenInputs>(searchParams);

    const form = reactive({
        jobQuery: searchParams.q ?? '',
        locationQuery: searchParams.location ?? '',
    });

    const pattern = helpers.regex(/^.{3,}$/);
    const rules = {
        jobQuery: {required, pattern},
        locationQuery: {maxLength: maxLength(500)},
    };

    const v$ = useVuelidate(rules, form);

    function onJobSelect(event: Event) {
        form.jobQuery = (event.target as HTMLInputElement).value;
    }

    function onSubmit(event: Event) {
        if (currentPage.value?.name === 'Search') {
            event.preventDefault();
            // pickBy will remove all null / undefined entries
            Hop.events.trigger('navbar:searchRequested', {
                reset: false,
                payload: {
                    ...pickBy(hiddenInputs.value),
                    q: form.jobQuery,
                    location: form.locationQuery,
                    ...(window.features.acquisitionAmplitudeTracking ? {sourceComponent: 'navbar_search'} : {}),
                },
            });
        }
    }

    return {
        hiddenInputs,
        v$,
        form,
        onJobSelect,
        onSubmit,
    };
}
